import { AssetDefinition } from '@/shared/hooks/api/appConfig'
import { GenericCombobox } from '@/common'
import { useTranslation } from 'react-i18next'

export function AssetInstanceSelect({
  assetDefinitions,
  onChange,
  question,
  selectedAssetDefinitionId,
  disabled
}: {
  assetDefinitions: AssetDefinition[]
  selectedAssetDefinitionId: string | null
  onChange: (assetDefinitionId: string | null) => void
  question?: string
  disabled?: boolean
}) {
  const { t } = useTranslation()

  const items = assetDefinitions
    .map(asset => {
      const label = t(`assets:${asset.id}`)
      return {
        label,
        value: asset.id
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <GenericCombobox
      value={
        selectedAssetDefinitionId
          ? { value: selectedAssetDefinitionId, label: t(`assets:${selectedAssetDefinitionId}`) }
          : null
      }
      label={question}
      onChange={item => onChange(item?.value ?? null)}
      items={items}
      disabled={disabled}
    />
  )
}
